// Extracts the base domain (second-level + top-level) from a hostname, e.g. "marketplace.quickframe.com" → "quickframe.com".
export const getBaseDomain = (hostname: string) => {
  const parts = hostname.split('.')
  return parts.slice(-2).join('.')
}

export const getBaseCookieDomain = (hostname: string) => {
  return `.${getBaseDomain(hostname)}`
}

export const getCookieDomain = (hostname: string) => {
  return `.${hostname}`
}
